import { FaHome } from "react-icons/fa"; 
import { Link } from "react-router-dom";
import version from './../../../package.json';
import AdmissionForm from "./AdmissionForm";
import { useDispatch, useSelector } from "react-redux";
import authService from "../../services/auth.service";
import { useEffect } from "react";


const AdmissionBaseLayout = ({part,course,courseFullName,type}) => {

     const dispatch = useDispatch();
      
      useEffect(() => {
         authService.getUser(dispatch);
      }, []);
  
    const studentInformation = useSelector((state) => state.auth.studentData);
  
  

  return (
     <div className="admission-container">
      
      <ul className="application_info">
        <li>
          {/* <a style={{color:'inherit'}} href="/student-dashboard">
              <FaHome />
            </a> */}
        </li>
        <li>
          2025-2026 - Application for {courseFullName}({course})-{part}-1 
        </li>
        <li>
            v-{version.version}
        </li>
      </ul>
      

      <div className="form-container">
          <AdmissionForm type={type} course={course} studentInformation={studentInformation}/>
      </div>
    </div>
  );
};

export default AdmissionBaseLayout;
